import React from 'react';
import './bilateralImage.scss';
import Img from 'gatsby-image';
import { getFluidGatsbyImage } from 'gatsby-source-sanity';
import clientConfig from '../../../../client-config';

const BilateralImage = ({ src, alt }) => {
  return (
    <div className="bilateral-image" id={"bilateral-image-"+alt}>
      <Img  fluid={getFluidGatsbyImage(src, { maxWidth: 675 }, clientConfig.sanity)} alt={alt} />
    </div>
  );
};
export default BilateralImage;
